exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.details .icon[data-v-d65b3b7a] {\n  font-size: 30px;\n}\n.reporting-item[data-v-d65b3b7a] {\n  float: left;\n  width: 33.33%;\n  padding: 1rem 2rem;\n  cursor: pointer;\n}\n", ""]);

// exports
